import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { FarmingPool, FarmingPoolData } from "types";
import Button from "components/Button/Button";
import UserStore from "stores/UserStore";
import PoolStore from "stores/PoolStore";

type Props = {
  pool: FarmingPool;
  data: FarmingPoolData;
};

const DepositWithdrawClaim = observer(({ pool, data }: Props) => {
  const [inputValue, setInputValue] = useState<number | undefined>(undefined);
  let stakingTokenName = pool.stakingToken.name;
  const stakingTokenBalance = UserStore.balances.get(stakingTokenName);
  if (!stakingTokenBalance == null) return null;
  const { stake, hasStakingAllowance } = data;
  return (
    <>
      <div className="section-asset-balance top-level-item">
        <span className="asset-balance-text">wallet</span>
        <div className="section-item-value">
          {stakingTokenBalance ? stakingTokenBalance.toFixed(9) : 0.0}
          <span className="asset-balance-text">{stakingTokenName}</span>
        </div>
      </div>
      {hasStakingAllowance ? (
        <>
          <input
            className="section-interactions-input"
            type="number"
            value={inputValue}
            placeholder="Set a withdraw/deposit amount"
            onChange={(e) => {
              const amount = parseFloat(e.target.value);
              if (amount <= stakingTokenBalance!) {
                setInputValue(amount);
              } else if (stake && amount > stakingTokenBalance! && amount <= stake) {
                setInputValue(amount);
              } else if (!stake && amount > stakingTokenBalance!) {
                setInputValue(stakingTokenBalance);
              } else {
                setInputValue(undefined);
              }
            }}
          />
          <div className="interaction-buttons">
            <Button
              type="normal"
              className="interaction-button top-level-item"
              onClick={() => inputValue && PoolStore.stake(pool, inputValue)}
            >
              Deposit
            </Button>
            <Button type="normal" className="interaction-button top-level-item" onClick={() => PoolStore.stake(pool, stakingTokenBalance!)}>
              Max ({stakingTokenBalance!.toFixed(8)})
            </Button>
            <Button
              type="normal"
              className="interaction-button top-level-item"
              onClick={() => inputValue && PoolStore.withdraw(pool, inputValue)}
            >
              Withdraw
            </Button>
            <Button type="normal" className="interaction-button top-level-item" onClick={() => stake && PoolStore.withdraw(pool, stake)}>
              Max ({stake?.toFixed(8)})
            </Button>
          </div>
        </>
      ) : (
        <Button
          type="positive"
          className="interaction-button top-level-item approval-button"
          onClick={() => PoolStore.getAllowance(pool, pool.stakingToken)}
        >
          Approve {stakingTokenName} before you can interact
        </Button>
      )}
    </>
  );
});

export default DepositWithdrawClaim;
